export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-lucide-at-sign', 'text-n-blue-11'],
  CONVERSATION_ASSIGNMENT: ['i-lucide-chevrons-right', 'text-n-blue-11'],
  CONVERSATION_CREATION: ['i-lucide-mail-plus', 'text-n-blue-11'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-11',
  ],
  SLA_MISSED_FIRST_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  VOICE_CALL_MISSED: ['i-lucide-phone-missed', 'text-n-ruby-11'],
  WGPT_BOARD_LIST_CARD_UPDATED: ['i-lucide-edit', 'text-n-blue-text'],
  WGPT_BOARD_LIST_CARD_ACTIVITY_CREATED: [
    'i-lucide-message-square-plus',
    'text-n-blue-text',
  ],
  WGPT_BOARD_LIST_CARD_ACTIVITY_UPDATED: ['i-lucide-edit', 'text-n-blue-text'],
  WGPT_BOARD_LIST_CARD_ACTIVITY_DELETED: ['i-lucide-trash-2', 'text-n-ruby-11'],
  WGPT_BOARD_LIST_CARD_ASSIGN: ['i-lucide-chevrons-right', 'text-n-blue-text'],
  WGPT_BOARD_LIST_CARD_MENTION: ['i-lucide-at-sign', 'text-n-blue-text'],
  WGPT_BOT_EVAL_CRITICAL_ISSUE: ['i-lucide-triangle-alert', 'text-n-ruby-11'],
};
